import React, { createContext } from 'react';
import PropTypes from 'prop-types';

const SMHeaderContext = createContext({});

const { Provider } = SMHeaderContext;

const HeaderContext = props => (
  <Provider
    value={{
      ...props
    }}
  >
    {props.children}
  </Provider>
);

HeaderContext.propTypes = {
  children: PropTypes.node.isRequired
};

export { SMHeaderContext, HeaderContext };
